import style from "./instance-line.module.css";
import { CollaborationIcon } from "frontend/icons/collaboration";

export function InstanceLine({
  name,
  openMembersModal,
  membersCount,
}: {
  name: string;
  openMembersModal: () => void;
  membersCount: number;
}) {
  return name.length > 0 ? (
    <div className={style.userLine}>
      <div className={style.container}>
        <div className={style.thumbnail}>
          <CollaborationIcon />
        </div>
        <div className={style.innerContainer}>
          <div className={style.nameContainer}>
            <span className={style.name}>{name}</span>
            <span className={style.membersCount}>{membersCount} members</span>
          </div>
        </div>
      </div>
      <div onClick={openMembersModal} className={style.viewMembers}>
        View members
      </div>
    </div>
  ) : null;
}
